

import React from "react";
import { useEffect, useState } from "react";

const OnlineUsersDetails = ({ list }) => {
    
    return(
        <center>
            <div>iOS &ge; 12 ||
                Safari &ge; 12 ||
                Chrome &ge; 80 ||
                Firefox &ge; 78 ||
                Edge &ge; 80 ||
            </div><br/>
            <b>Online Users Details</b><br/>
                { 
                    list && list.map((o, index) => {
                        return (
                            
                                <div key={ index } 
                                    style={{ color: o.isLoggedIn ? 'green' : 'red'  }}>
                                    {/* { o.path } - { o.Username } - { o.device.toLowerCase() === "true" ? "📱" : "🖥️" }  */}
                                    {/* { o.path } - { o.device.toLowerCase() === "true" ? "📱" : "🖥️" } - { o.browser }  */}
                                    { o.isLoggedIn ? "🟢" : "🔴" } { o.username } - { o.path } - ({ o.browser }) - { o.Id }
                                </div>
                        )
                    })
                }
        </center>
    )
}

export default OnlineUsersDetails;